export default __webpack_public_path__ + "static/media/stick.6520406a.svg";